module.exports = __webpack_public_path__ + "static/media/project-detail-yellow-lines.6a9441c0.svg";